import { render } from "./MyTasks.vue?vue&type=template&id=7b85b4bf&ts=true"
import script from "./MyTasks.vue?vue&type=script&lang=ts"
export * from "./MyTasks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__